import { FeatureFlagEnum } from '../types/feature-flags'

export const SHOW_ME_EVERYTHING = 'showMeEverything'

// The feature flags an AM switches on in VT Admin, sent to success@ as the list to
// enable with no translation step; the backend rejects anything outside it.
export const COMPLETE_TRIAL_FEATURE_VALUES = [
  FeatureFlagEnum.multiLevelApproval,
  FeatureFlagEnum.hours,
  FeatureFlagEnum.accruals,
  FeatureFlagEnum.scheduledReports,
  FeatureFlagEnum.toil,
  FeatureFlagEnum.labels,
  FeatureFlagEnum.syncSharedCalendars,
  FeatureFlagEnum.substituteApprovers,
  SHOW_ME_EVERYTHING,
] as const

export type CompleteTrialFeatureValue = (typeof COMPLETE_TRIAL_FEATURE_VALUES)[number]
